"use client";
import { HUNDRED_YEARS_STORE } from "@/constants";

const hasDOM = (): boolean =>
  typeof window !== "undefined" && typeof document !== "undefined";

export const getStoredData = (
  name: string,
  option: "session" | "locale" = "locale",
): any | null => {
  if (typeof window === "undefined") return null;

  let data: string | null;
  try {
    if (option === "locale") data = localStorage.getItem(name);
    else data = sessionStorage.getItem(name);
  } catch {
    return null;
  }

  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

export const setStoredData = (
  name: string,
  data: any,
  option: "session" | "locale" = "locale",
) => {
  if (typeof window === "undefined") return;

  try {
    if (option === "locale") localStorage.setItem(name, JSON.stringify(data));
    else sessionStorage.setItem(name, JSON.stringify(data));
  } catch {}
};

export function getCookie(name: string): string | null {
  if (!hasDOM()) return null;

  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

export function setCookie(name: string, value: string): void {
  if (!hasDOM()) return;

  const expires = new Date(Date.now() + HUNDRED_YEARS_STORE).toUTCString();
  const secure = window.location.protocol === "https:" ? "; Secure" : "";

  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax${secure}`;
}

export function safeJsonParse<T>(value: string | null): T | null {
  if (!value) return null;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}
